import styles from '@features/voucher-new/styles/voucher-new.module.css';
import React from 'react';
import cn from 'classnames';

import { ImageList } from '@shared/config/constants/Images';
import { useUTMSource } from '@shared/hooks/useUTMSource';
import { VoucherFooter } from '@features/voucher-new/ui/components/VoucherFooter';
import { windowOpenBlank } from '@shared/utils';
import { useQuery } from '@shared/hooks';
import { useTranslation } from 'react-i18next';

export const VoucherThankYou = (props) => {
  const { activationURL } = props;
  const { t } = useTranslation();
  const { query } = useQuery();
  const UTMSourceURL = useUTMSource();

  const queryActivationUrl = query.get('activationUrl') || '';

  const handleRedirect = () => {
    windowOpenBlank(queryActivationUrl || activationURL, UTMSourceURL);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          <div className={styles.thankYouContent}>
            <div className={styles.wrapper}>
              <img src={ImageList.vip_banner_perks_2} alt="VipLogo" className={styles.imageStyle} />
              <div className={styles.centered}>
                <div className={styles.iconAndTitleWrapper}>
                  <svg width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="18" cy="18" r="18" fill="#074DFF" />
                    <rect
                      width="25.7143"
                      height="25.7143"
                      transform="translate(5.14258 5.14282)"
                      fill="#074DFF"
                    />
                    <path
                      d="M24.3514 11.5713L15.0571 20.8713L10.9429 16.7541L9 18.7141L15.0571 24.777L26.3171 13.5141L24.3514 11.5713Z"
                      fill="white"
                    />
                  </svg>
                  <span className={cn(styles.title, 'thankyou_govip_title')}>
                    {t('subscription_successful')}
                  </span>
                </div>
                <div className={styles.subTitleWrapper}>
                  <span className={cn(styles.subTitle, 'thankyou_govip_subtitle')}>
                    {t('you_can_now_access')}
                  </span>
                </div>
                <button className={styles.button} onClick={handleRedirect}>
                  <span className="thankyou_govip_buttontext">{t('buttonText')}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <VoucherFooter />
      </div>
    </div>
  );
};
